import React, { useState } from "react";
import HintLabel from "../HintLabel/HintLabel";
import InfoIcon from "../InfoIcon/InfoIcon";
import InputDescription from "../InputDescription/InputDescription";
import "./button.scss";

const Button = (props) => {
  const {
    className = "",
    disabled,
    description,
    pending,
    children,
    hintText,
    onClick,
  } = props;
  const [show, setShow] = useState(false);
  const handleToggle = () => setShow(!show);

  return (
    <div className="button-wrapper">
      <strong className="dcr-label"></strong>
      <div
        className={`button__inner-wrapper ${pending ? "pending-label" : ""}`}
      >
        <button
          type="button"
          className={`button ${className}`}
          disabled={disabled}
          onClick={onClick}
        >
          {children}
        </button>
        {description && <InfoIcon onClick={handleToggle} active={show} />}
      </div>
      <div>
        {hintText && <HintLabel>{hintText}</HintLabel>}
        {description && show && <InputDescription>{description}</InputDescription>}
      </div>
    </div>
  );
};

export default Button;
